import { NgModule } from '@angular/core';

import { BetBuilderDialogService } from './services/bet-builder-dialog.service';
import { BetBuilderUtilService } from './services/bet-builder-util.service';

@NgModule({
    providers: [BetBuilderUtilService, BetBuilderDialogService],
})
export class BetBuilderModule {}
